import styled from "styled-components"

import {
	MobergFontFamily,
	MobergFontSize,
} from "../../../../../Components/MobergFont/MobergFont"

export const ModalContainer = styled.div<{ $variant: "calibration" | "status" }>`
	max-width: ${({ $variant }) => ($variant === "calibration" ? "1000px" : "500px")};
	width: min(95vw, ${({ $variant }) => ($variant === "calibration" ? "1000px" : "600px")});
	${({ $variant }) =>
		$variant === "calibration" ? "max-height: 90vh; min-height: 700px;" : ""};
	background: var(--color-surface-panel);
	border-radius: 4px;
	box-shadow: var(--modal-box-shadow);
	display: flex;
	flex-direction: column;
	overflow: hidden;
	${({ $variant }) =>
		$variant === "calibration"
			? `
		position: fixed;
		top: 5vh;
		left: 50%;
		transform: translateX(-50%);
	`
			: ""};
`

export const ModalHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 24px 12px 24px;
	border-bottom: 1px solid var(--color-border-light);
`

export const ModalTitle = styled.h2`
	font-family: ${MobergFontFamily.HEADER};
	font-size: ${MobergFontSize.LARGE};
	font-weight: 600;
	color: var(--color-text-primary);
	margin: 0;
`

export const ModalContent = styled.div<{ $isCalibration: boolean }>`
	flex: 1;
	padding: ${({ $isCalibration }) => ($isCalibration ? "28px 32px" : "24px")};
	display: flex;
	flex-direction: column;
	align-items: ${({ $isCalibration }) => ($isCalibration ? "center" : "stretch")};
	gap: 24px;
	min-height: 0;
`
